import fromDateToDayOfTheWeek from 'bl/scheduler/fromDateToDayOfTheWeek.bl';
import withOptions from 'utils/functions/withOptions.util';
import asObject from 'utils/objects/asObject.util';

const determineOpeningInterval = withOptions(({ hours: hoursFromOptions, bgn, end }) => {
  const bgnWeekday = fromDateToDayOfTheWeek(bgn);
  const endWeekday = fromDateToDayOfTheWeek(end);

  const hours = asObject(hoursFromOptions);

  const open = asObject(hours[bgnWeekday]).open_time || '';
  const close = asObject(hours[endWeekday]).close_time || '';

  return { open, close, bgnWeekday, endWeekday };
});

export default determineOpeningInterval;
